import React from "react";
import Grid from "@mui/material/Grid";
import _includes from "lodash/includes";
import Typography from "@mui/material/Typography";
import SummaryDetailsItem from "../../Common/SummaryDetailsItem/SummaryDetailsItem";
import { scrollToAnchor } from "../../../../theme/commonStyle";
import { Box } from "@mui/material";
import { Person } from "../../../../types/Entities/Person";

interface ContractDataProps {
  caseData: any;
}

const ContractData = ({ caseData }: ContractDataProps) => {
  const caseCategory = caseData.caseCategory;
  const anchorId = "contractData";

  return (
    <>
      <Box id={anchorId} sx={scrollToAnchor} />
      <Grid
        sx={{ marginTop: "2rem", borderBottom: "1px solid #333", "& h5": { lineHeight: "1rem" } }}
        size={12}>
        <Typography variant={"h5"}>Ihr Vertrag</Typography>
      </Grid>
      <SummaryDetailsItem fieldPath={"customer.person.gender"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"customer.person.givenName"} caseData={caseData} />
      <SummaryDetailsItem fieldPath={"customer.person.familyName"} caseData={caseData} />
      {caseCategory !== "advisory" && caseData.clientIsCustomer === true && (
        <>
          <SummaryDetailsItem fieldPath={"customer.person.residenceAddress.streetAddress"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"customer.person.residenceAddress.postalCode"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"customer.person.residenceAddress.addressLocality"} caseData={caseData} />
        </>
      )}
      <SummaryDetailsItem fieldPath={"customer.telephone"} caseData={caseData} />
      {caseCategory !== "advisory" && caseData.clientIsCustomer !== true && (
        <>
          <SummaryDetailsItem fieldPath={"client.gender"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"client.givenName"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"client.familyName"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"client.residenceAddress.streetAddress"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"client.residenceAddress.postalCode"} caseData={caseData} />
          <SummaryDetailsItem fieldPath={"client.residenceAddress.addressLocality"} caseData={caseData} />
          {caseData.clientWasMinorAtContractDate && (
            <>
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.gender"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.givenName"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.familyName"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.residenceAddress.streetAddress"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.residenceAddress.postalCode"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientLegalRepresentative.residenceAddress.addressLocality"} caseData={caseData} />

              {caseData.clientLegalRepresentativeAmount === 2 && (
                <>
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.gender"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.givenName"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.familyName"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.residenceAddress.streetAddress"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.residenceAddress.postalCode"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"secondClientLegalRepresentative.residenceAddress.addressLocality"} caseData={caseData} />
                  <SummaryDetailsItem fieldPath={"clientLegalRepresentativesAuthorizationType"} caseData={caseData} />
                </>
              )}
            </>
          )}
        </>
      )}
      {caseCategory !== "advisory" && <SummaryDetailsItem fieldPath={"contractDate"} caseData={caseData} fieldType={"date"} />}
      {caseData.additionalClients?.map((client: Person, index: number) => (
        <React.Fragment key={index}>
          <SummaryDetailsItem fieldPath={`additionalClients[${index}].gender`} caseData={caseData} labelPostfix={`${index + 2}. Vertragsabschließender`} />
          <SummaryDetailsItem fieldPath={`additionalClients[${index}].givenName`} caseData={caseData} labelPostfix={`${index + 2}. Vertragsabschließender`} />
          <SummaryDetailsItem fieldPath={`additionalClients[${index}].familyName`} caseData={caseData} labelPostfix={`${index + 2}. Vertragsabschließender`} />
        </React.Fragment>
      ))}
      {caseCategory === "enforceClaim" && (
        <>
          {caseData.name !== "dataLeakContract" && (
            <>
              <SummaryDetailsItem fieldPath={"objectiveClient"} caseData={caseData} />
              <SummaryDetailsItem fieldPath={"clientHasAlreadyClaimed"} caseData={caseData} />
            </>
          )}

          {caseData.clientHasAlreadyClaimed === "yes" && <SummaryDetailsItem fieldPath={"claimedDateClient"} caseData={caseData} fieldType={"date"} />}

          {caseData.name !== "dataLeakContract" && <SummaryDetailsItem fieldPath={"subjectOfDispute"} caseData={caseData} />}

          {caseData.subjectOfDispute === "money" && (
            <>
              <SummaryDetailsItem fieldPath={"claimedAmountClient"} caseData={caseData} fieldType={"money"} />
              <SummaryDetailsItem fieldPath={"client.bankData.iban"} caseData={caseData} />
            </>
          )}
        </>
      )}
      {caseCategory === "defendClaim" && (
        <>
          <SummaryDetailsItem fieldPath={"defenseProcessStatus"} caseData={caseData} />

          {caseData.defenseProcessStatus === "paymentOrder" && <SummaryDetailsItem fieldPath={"paymentOrderDate"} caseData={caseData} fieldType={"date"} />}
          {caseData.defenseProcessStatus === "enforcementOrder" && (
            <SummaryDetailsItem fieldPath={"enforcementOrderDate"} caseData={caseData} fieldType={"date"} />
          )}
          {caseData.defenseProcessStatus === "lawsuit" && <SummaryDetailsItem fieldPath={"statementOfClaimFiledDate"} caseData={caseData} />}

          {_includes(["paymentOrder", "reminder", "lawsuit"], caseData.defenseProcessStatus) && (
            <SummaryDetailsItem fieldPath={"contractualPartnerHasLawyer"} fieldType={"yesNo"} caseData={caseData} />
          )}
          {caseData.contractualPartnerHasLawyer === true && (
            <>
              <SummaryDetailsItem fieldPath={"opponentLawyer.gender"} caseData={caseData} labelPostfix={"Anwalt"} />
              <SummaryDetailsItem fieldPath={"opponentLawyer.givenName"} caseData={caseData} labelPostfix={"Anwalt"} />
              <SummaryDetailsItem fieldPath={"opponentLawyer.familyName"} caseData={caseData} labelPostfix={"Anwalt"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.name"} caseData={caseData} labelPostfix={"Kanzlei"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.address.streetAddress"} caseData={caseData} labelPostfix={"Kanzlei"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.address.postalCode"} caseData={caseData} labelPostfix={"Kanzlei"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.address.addressLocality"} caseData={caseData} labelPostfix={"Kanzlei"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.mainEmail.email"} caseData={caseData} labelPostfix={"Kanzlei"} />
              <SummaryDetailsItem fieldPath={"opponentLawFirm.organization.telephone"} caseData={caseData} labelPostfix={"Kanzlei"} />
            </>
          )}
          <SummaryDetailsItem fieldPath={"subjectOfDispute"} caseData={caseData} labelPostfix={"Gegenseite"} />

          {caseData.subjectOfDispute === "money" && (
            <>
              <SummaryDetailsItem fieldPath={"claimedAmountClient"} caseData={caseData} fieldType={"money"} labelPostfix={"Gegenseite"} />
              {_includes(["reminder", "debtCollection"], caseData.defenseProcessStatus) && (
                <SummaryDetailsItem fieldPath={"overdueFees"} caseData={caseData} fieldType={"money"} />
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default ContractData;
